import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import getSymbolFromCurrency from 'currency-symbol-map'
import countryToCurrency from "country-to-currency";
import * as lookup from 'country-code-lookup';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const showMocks = () => process.env.NODE_ENV === "development"

export const getCurrencyCodeFromCountryCode = (countryCode: string) => {
  const currencyCode = countryToCurrency[countryCode.toUpperCase() as keyof typeof countryToCurrency];

  return currencyCode
}

export const getCurrencySymbol = (currencyCode: string) => getSymbolFromCurrency(currencyCode);

export const getCurrencySymbolFromCountryCode = (countryCode: string) => {
  return getCurrencySymbol(getCurrencyCodeFromCountryCode(countryCode))
}

export const formatDate = (dateString: string | Date): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

export const fmtShort = (d: string | Date) => new Date(d).toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });

export const formatPercentage = (value: number | null | undefined): string => {
  if (value === null || value === undefined) return 'N/A';

  return `${(value * 100).toFixed(2)}%`;
};

export const getCountryNameFromCode = (countryCode: string): string => {
  if (!countryCode || countryCode === 'unknown') {
    return 'Unknown Location';
  }

  try {
    const country = lookup.byIso(countryCode);
    return country ? country.country : countryCode;
  } catch {
    return countryCode;
  }
};


export const extractBookingPath = (inputText: string): string | null => {
  if (!inputText || typeof inputText !== 'string') {
    return null;
  }

  // Skip if it doesn't look like a booking path at all
  if (!inputText.includes('hotel/')) {
    return null;
  }

  let path = inputText;

  // Handle full URLs with "booking.com"
  const bookingIndex = path.indexOf('booking.com');
  if (bookingIndex !== -1) {
    path = path.substring(bookingIndex + 'booking.com'.length);
  }

  // Remove query parameters (anything after ?)
  const queryIndex = path.indexOf('?');
  if (queryIndex !== -1) {
    path = path.substring(0, queryIndex);
  }

  // Remove leading slash if present
  if (path.startsWith('/')) {
    path = path.substring(1);
  }

  return path;
};